'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var h = require('react').createElement;
var Box = require('./Box');

var _require = require('./util'),
    idx = _require.idx;

var Text = function Text(_ref, context) {
  var bold = _ref.bold,
      center = _ref.center,
      props = _objectWithoutProperties(_ref, ['bold', 'center']);

  return h(Box, _extends({}, props, {
    css: _extends({}, props.css, {
      fontWeight: bold ? idx(['axs', 'bold'], context) || 700 : idx(['css', 'fontWeight'], props),
      textAlign: center ? 'center' : null
    })
  }));
};

module.exports = Text;


//////////////////
// WEBPACK FOOTER
// ./~/axs/dist/Text.js
// module id = 103
// module chunks = 0